const locale ={
    HELP :"帮助",
    PRIVACY:"隐私",
    TERMS:"T条款",
}

export default locale